import { action, computed, observable } from 'src_common/common/mobx-wrapper';
import { ChangeEvent } from 'react';
import { SingleTagType } from 'src/AppState/sdk/staff';
import {
    MarketTemplateSettingsFormState,
    UpdateTemplateBody,
} from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm.state';
import { SelectionNewTradingType } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelections';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';
import { makeAutoObservable } from 'mobx';

type TagDetails = SingleTagType[1];
export class MarketTemplateSelectionNewTradingState {
    @observable openedSelections: Array<string> = [];
    readonly inputState: FormInputState<string | null | undefined, string | null | undefined>;

    constructor(
        readonly selection: SelectionNewTradingType,
        readonly marketTemplateSettingsFormState: MarketTemplateSettingsFormState,
        readonly marketTemplateState: SportMarketTemplatesState
    ) {
        this.inputState = FormInputState.new(selection.namePattern);
        makeAutoObservable(this);
    }
    @action toggleSelection = (): void => {
        const name = this.selection.namePattern;
        if (name !== null && name !== undefined) {
            this.openedSelections.includes(name) === false
                ? this.openedSelections.push(name)
                : (this.openedSelections = this.openedSelections.filter((name) => name !== this.selection.namePattern));
        }
    };

    onChangeAutoCreate = (data: UpdateTemplateBody): void => {
        const selection = this.selection;
        // @ts-expect-error -> temporary turn off, proxy refactor
        selection.autoCreate = data.autoCreate;
        this.marketTemplateSettingsFormState.onChangeSelectionsNewTrading(this.selection);
    };

    onSelectionNameChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const selection = this.selection;
        const oldName = selection.namePattern;
        this.inputState.setValue(e.target.value);
        selection.namePattern = e.target.value;
        this.marketTemplateSettingsFormState.onChangeSelectionsNewTrading(selection, oldName ?? undefined);
    };

    onEditName = (e: ChangeEvent<HTMLInputElement>): void => {
        this.inputState.setValue(e.target.value);
    };

    onTagChange = (value: string, target: string): void => {
        const selection = this.selection;
        selection.metadata = {
            ...selection.metadata,
            [target]: value,
        };

        this.marketTemplateSettingsFormState.onChangeSelectionsNewTrading(selection);
    };

    @computed get tagsForSelections(): Array<Record<string, TagDetails>> {
        const out: Array<Record<string, TagDetails>> = [];
        const tags = this.marketTemplateState.getTags;
        if (this.marketTemplateState.getTags !== 'loading') {
            const filtered = Object.entries(tags).filter((item) => item[1].applicableTo.includes('selection-template'));
            filtered.forEach((item) => {
                out.push({ [item[0]]: item[1] });
            });
        }
        return out;
    }
}
